var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDestino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circleIconState",
    d: "M17.9375 35.5066C27.6025 35.5066 35.4375 27.6716 35.4375 18.0066C35.4375 8.34161 27.6025 0.506592 17.9375 0.506592C8.27252 0.506592 0.4375 8.34161 0.4375 18.0066C0.4375 27.6716 8.27252 35.5066 17.9375 35.5066Z",
    fill: "#C7B301"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2127 19.2712H26.096C25.714 19.2712 25.4043 19.5809 25.4043 19.9629V21.9079C25.4043 22.2899 25.714 22.5996 26.096 22.5996H31.2127C31.5948 22.5996 31.9044 22.2899 31.9044 21.9079V19.9629C31.9044 19.5809 31.5948 19.2712 31.2127 19.2712Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5506 15.1103H22.4339C22.0519 15.1103 21.7422 15.42 21.7422 15.802V17.747C21.7422 18.129 22.0519 18.4387 22.4339 18.4387H27.5506C27.9327 18.4387 28.2423 18.129 28.2423 17.747V15.802C28.2423 15.42 27.9327 15.1103 27.5506 15.1103Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5506 23.4323H22.4339C22.0519 23.4323 21.7422 23.742 21.7422 24.124V26.069C21.7422 26.4511 22.0519 26.7608 22.4339 26.7608H27.5506C27.9327 26.7608 28.2423 26.4511 28.2423 26.069V24.124C28.2423 23.742 27.9327 23.4323 27.5506 23.4323Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4729 17.0066C20.1675 17.0066 22.35 14.8241 22.35 12.1295C22.35 9.43493 20.1675 7.25244 17.4729 7.25244C14.7783 7.25244 12.5958 9.43493 12.5958 12.1295C12.5958 14.8241 14.7783 17.0066 17.4729 17.0066Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2525 19.4475C13.9335 19.5181 7.71875 21.1506 7.71875 24.3222V26.7607H20.9844C20.8843 26.5513 20.8283 26.3167 20.8283 26.069V24.124C20.8283 23.9081 20.8709 23.7021 20.9481 23.514H18.7742C17.8872 23.514 17.1681 22.7949 17.1681 21.9079V19.9628C17.1681 19.7826 17.1978 19.6093 17.2525 19.4475Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8905 19.2712H18.7737C18.3917 19.2712 18.082 19.5809 18.082 19.9629V21.9079C18.082 22.2899 18.3917 22.5996 18.7737 22.5996H23.8905C24.2725 22.5996 24.5822 22.2899 24.5822 21.9079V19.9629C24.5822 19.5809 24.2725 19.2712 23.8905 19.2712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDestino);
export default __webpack_public_path__ + "static/media/no-destino.086fffd2993fc1ced52e8c9f78c65ef1.svg";
export { ForwardRef as ReactComponent };